"use client";

import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!videoRef.current) return;
    let animationFrame: number;
    let scale = 1;
    const targetScale = 1.1;
    const duration = 12000;
    const startTime = Date.now();
    const animate = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      scale = 1 + (targetScale - 1) * progress;
      if (videoRef.current) {
        videoRef.current.style.transform = `scale(${scale})`;
      }
      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      }
    };
    animate();
    return () => {
      if (animationFrame) {
        cancelAnimationFrame(animationFrame);
      }
    };
  }, []);
  return <section id="hero" className="dark bg-background text-foreground relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div ref={videoRef} className="absolute inset-0 bg-cover bg-center !bg-[url(https://bodegajulian.es/wp-content/uploads/2026/02/Captura-de-pantalla-2026-02-07-a-las-14.51.41.png)] transition-transform duration-[12000ms] ease-linear !border-dashed !border-1 border-[rgb(255,255,255)]" style={{
        transformOrigin: "center center"
      }} />
        
        <div className="absolute inset-0 pointer-events-none" style={{
        background: `radial-gradient(ellipse 90% 85% at 50% 50%, transparent 40%, rgba(2, 2, 3, 0.4) 70%, rgba(2, 2, 3, 0.9) 100%)`
      }} />
      </div>

      <div ref={contentRef} className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h1 className="font-display text-5xl font-bold tracking-tight mb-6 text-foreground drop-shadow-[0_2px_8px_rgba(0,0,0,0.8)] !h-[325.586px] md:text-7xl lg:text-8xl">Restaurante <br />Bodega Julian, <br />Puerto de La Cruz.</h1>
        
        <p className="text-xl md:text-2xl lg:text-3xl font-light text-accent mb-4 max-w-2xl mx-auto leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">
          Tradición y corazón en cada bocado, el mejor restaurante en el Puerto de La Cruz
        </p>
        
        <p className="text-base md:text-lg text-muted-foreground mb-10 max-w-xl mx-auto leading-relaxed drop-shadow-[0_1px_4px_rgba(0,0,0,0.8)]">
          Cocina casera con alma, vinos con historia, restaurante con sabor canario-español en el corazón del Puerto de la Cruz, Tenerife.
        </p>

        <Link to="#reservation-form">
          <Button size="lg" className="btn-primary text-lg px-10 py-6 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] !bg-[hsl(26,90%,37%)] hover:scale-[1.02] hover:shadow-strong active:scale-[0.98]">Reserva ahora</Button>
        </Link>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent pointer-events-none" />
    </section>;
}